import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const TESTIMONIALS = [
  {
    name: "Sylvain M.",
    role: "Syndic professionnel",
    photo:
      "https://images.pexels.com/photos/33345085/pexels-photo-33345085.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "Nos AG hybrides sont devenues un jeu : feuille de présence digitale, vote sécurisé et PV généré à la clôture. Mes copropriétaires adorent.",
  },
  {
    name: "Claire D.",
    role: "Présidente de syndic bénévole",
    photo:
      "https://images.unsplash.com/photo-1641937259750-1ab659ff1aa5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBmcmVuY2glMjBwZXJzb24lMjBwb3J0cmFpdCUyMHNtaWxpbmclMjBoZWFkc2hvdHxlbnwwfHx8fDE3OTI2MTUzODB8MA&ixlib=rb-4.1.0&q=85",
    quote:
      "La messagerie a transformé la vie de notre résidence : fini les dizaines d'emails, tout le fil des échanges est dans l'application.",
  },
  {
    name: "Marie L.",
    role: "Copropriétaire",
    photo:
      "https://images.pexels.com/photos/30049747/pexels-photo-30049747.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "J'ai voté depuis mon canapé pendant l'AG en visio. Simple, sécurisé, et le procès-verbal est arrivé en LRE.",
  },
  {
    name: "Sophie R.",
    role: "Copropriétaire",
    photo:
      "https://images.unsplash.com/photo-1713952704614-76630700a4b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBmcmVuY2glMjBwZXJzb24lMjBwb3J0cmFpdCUyMHNtaWxpbmclMjBoZWFkc2hvdHxlbnwwfHx8fDE3OTI2MTUzODB8MA&ixlib=rb-4.1.0&q=85",
    quote:
      "Un incident déclaré depuis mon téléphone avec la photo, suivi jusqu'à l'intervention : zéro allers-retours.",
  },
];

export const Testimonials = () => (
  <section id="temoignages" className="bg-white py-24 lg:py-32" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, ease: EASE }}
        className="max-w-3xl"
      >
        <span className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-electric">
          <span className="h-px w-10 bg-electric" />
          Témoignages
        </span>
        <h2 className="mt-6 text-4xl font-bold tracking-normal leading-[1.15] text-ink md:text-5xl">
          Ils vivent la copro{" "}
          <span className="bg-[linear-gradient(100deg,#00C6CC,#2FCB74)] bg-clip-text text-transparent">
            différemment.
          </span>
        </h2>
      </motion.div>

      <div className="mt-14 grid gap-6 md:grid-cols-2">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.name}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: (i % 2) * 0.12, ease: EASE }}
            whileHover={{ y: -5 }}
            className="flex h-full flex-col rounded-3xl border border-black/5 bg-mist p-8 shadow-[0_20px_55px_-30px_rgba(45,52,54,0.3)] transition-shadow duration-300 hover:shadow-[0_30px_70px_-30px_rgba(0,190,200,0.5)]"
            data-testid={`testimonial-card-${i}`}
          >
            <div className="flex items-center justify-between">
              <div className="flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={15} className="fill-gold text-gold" />
                ))}
              </div>
              <Quote size={22} className="text-electric/30" />
            </div>
            <blockquote className="mt-5 flex-1 text-[15px] leading-relaxed text-ink/75">
              « {t.quote} »
            </blockquote>
            <figcaption className="mt-6 flex items-center gap-4">
              <img
                src={t.photo}
                alt={`Portrait de ${t.name}`}
                className="h-14 w-14 rounded-full object-cover ring-2 ring-electric/30"
              />
              <span>
                <span className="block text-sm font-bold text-ink">{t.name}</span>
                <span className="block text-xs font-semibold text-ink/45">{t.role}</span>
              </span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
